import React, { useEffect, useRef } from 'react';
import {Box, Button, Stack, Typography} from '@mui/material';
import Logo from "../../assets/logo.png";
import DrTorres from "../../assets/Especialistas/Dr. Héctor Leonardo Torres Soltero.png";

const MAX_TILT = 40;

const lerp = (a, b, t) => a + (b - a) * t;

const CelularItem = () => {
  const phoneRef = useRef(null);
  const frameRef = useRef(null);
  //const [mode, setMode] = useState('full');

  const stateRef = useRef({
    rx: 0,
    ry: 0,
    priv: 0,

    targetRx: 0,
    targetRy: 0,
    targetPriv: 0,
  });

  const sceneRef = useRef(null);

  useEffect(() => {
    const animate = () => {
      const s = stateRef.current;

      // DESCOMENTAR PARA RECUPERAR MOVIMIENTO
      // Suavizado
      // s.rx = lerp(s.rx, s.targetRx, 0.08);
      // s.ry = lerp(s.ry, s.targetRy, 0.08);
      // s.priv = lerp(s.priv, s.targetPriv, 0.1);

      if (phoneRef.current) {
        phoneRef.current.style.transform = `
          rotateX(${s.rx}deg)
          rotateY(${s.ry}deg)
        `;
      }

      frameRef.current = requestAnimationFrame(animate);
    };

    frameRef.current = requestAnimationFrame(animate);

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleMove = (e) => {
      if (!phoneRef.current) return;

      const s = stateRef.current;

      s.hasInteracted = true;

      const rect = phoneRef.current.getBoundingClientRect();

      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      const dx = e.clientX - cx;
      const dy = e.clientY - cy;

      const maxDist =
        Math.min(window.innerWidth, window.innerHeight) * 0.45;

      const dist = Math.sqrt(dx * dx + dy * dy);

      const normDist = Math.min(dist / maxDist, 1);

      s.targetRy = (dx / maxDist) * MAX_TILT;
      s.targetRx = -(dy / maxDist) * MAX_TILT;

      s.targetRy = Math.max(
        -MAX_TILT,
        Math.min(MAX_TILT, s.targetRy)
      );

      s.targetRx = Math.max(
        -MAX_TILT,
        Math.min(MAX_TILT, s.targetRx)
      );

      s.targetPriv = Math.pow(normDist, 1.3) * 0.95;
    };

    const handleLeave = () => {
      const s = stateRef.current;

      // Volver al frente
      s.targetRx = 0;
      s.targetRy = 0;
      s.targetPriv = 0;
    };

    const sceneElement = sceneRef.current;

    if (sceneElement) {
      sceneElement.addEventListener('mouseleave', handleLeave);
    }

    if (sceneElement) {
      sceneElement.addEventListener('mousemove', handleMove);
    }

    return () => {
      if (sceneElement) {
        sceneElement.removeEventListener('mousemove', handleMove);
      }

      if (sceneElement) {
        sceneElement.removeEventListener('mouseleave', handleLeave);
      }
    };
  }, []);

  return (
    <Box
      // ref={sceneRef}
      sx={{
        width: '100%',
        minHeight: '100vh',
        bgcolor: '#f0eeeb',
        display: 'grid',
        placeItems: 'center',
        overflow: 'hidden',
        p: 3,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={6}
        alignItems="center"
        // sx={{
        //   perspective: '800px',
        // }}
      >

        <Box ref={sceneRef} sx={{
          perspective: '800px',
        }}>
          {/* PHONE */}
          <Box
            ref={phoneRef}
            sx={{
              width: { xs: 224, md: 256, lg: 306 },
              height: { xs: 469, md: 537, lg: 641 },
              position: 'relative',
              transformStyle: 'preserve-3d',
              borderRadius: '30px',
              boxShadow: '0 30px 80px rgba(0,0,0,0.12)',
              willChange: 'transform',
            }}
          >
            {/* BACK */}
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '30px',
                background: 'linear-gradient(160deg, #c0d0de, #a8bcd0, #b4c4d4)',
                transform: 'translateZ(-16px)',
              }}
            />

            {/* RIGHT EDGE */}
            <Box
              sx={{
                position: 'absolute',
                top: 30,
                bottom: 30,
                right: 0,
                width: 16,
                transformOrigin: 'right center',
                transform: 'rotateY(-90deg)',
                background:'linear-gradient(180deg, #c8d8e5, #a8b8ca, #b8c8d6)',
              }}
            />

            {/* LEFT EDGE */}
            <Box
              sx={{
                position: 'absolute',
                top: 30,
                bottom: 30,
                left: 0,
                width: 16,
                transformOrigin: 'left center',
                transform: 'rotateY(90deg)',
                background:'linear-gradient(180deg, #c8d8e5, #a8b8ca, #b8c8d6)',
              }}
            />

            {/* TOP EDGE */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 30,
                right: 30,
                height: 16,
                transformOrigin: 'center top',
                transform: 'rotateX(-90deg)',
                background: 'linear-gradient(90deg, #c0d0de, #b0c2d2, #c4d4e2)',
              }}
            />

            {/* BOTTOM EDGE */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 30,
                right: 30,
                height: 16,
                transformOrigin: 'center bottom',
                transform: 'rotateX(90deg)',
                background: 'linear-gradient(90deg, #b0c0d0, #a0b0c2, #b8c8d6)',
              }}
            />

            {/* BEZEL */}
            <Box
              sx={{
                width: '100%',
                height: '100%',
                background:'linear-gradient(160deg, #d0dde8, #b8cad8, #c4d4e2)',
                borderRadius: '30px',
                p: '3px',
                position: 'relative',
                transform: 'translateZ(1px)',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  bgcolor: '#080808',
                  borderRadius: '27px',
                  p: '3px',
                }}
              >
                {/* SCREEN */}
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '24px',
                    overflow: 'hidden',
                    position: 'relative',
                    bgcolor: '#080808',

                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      top: 10,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 11,
                      height: 11,
                      borderRadius: '50%',
                      bgcolor: '#060606',
                      zIndex: 30,
                    },
                  }}
                >
                  {/* WALLPAPER */}
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      background: `
                        radial-gradient(
                          ellipse 55% 45% at 60% 35%,
                          rgba(62, 117, 235, 0.9),
                          transparent 70%
                        ),
                        radial-gradient(
                          ellipse 50% 55% at 35% 60%,
                          rgba(89, 96, 233, 0.7),
                          transparent 65%
                        ),
                        linear-gradient(
                          155deg,
                          #3a43ff 0%,
                          #686ff4 25%,
                          #757aea 45%,
                          #666ce8 55%,
                          #6167e3 75%,
                          #4950e2 100%
                        )
                      `,
                    }}
                  />

                  {/* STATUS BAR */}
                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 10,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      px: 2,
                      pt: 0.5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '0.62rem',
                        fontWeight: 700,
                        color: 'rgba(255,255,255,0.92)',
                      }}
                    >
                      12:45
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '0.62rem',
                        color: 'rgba(255,255,255,0.92)',
                      }}
                    >
                      LTE 🔋
                    </Typography>
                  </Box>

                  {/* NOTIFICATION */}
                  <Box
                    sx={{
                      mt: 4,
                      mx: 1.2,
                      padding:"9px 8px",
                      borderRadius: '18px',
                      position: 'relative',
                      zIndex: 10,
                      background: 'rgba(18,16,26,0.72)',
                      backdropFilter: 'blur(24px)',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {xs:'0.52rem', lg:'0.62rem'},
                        color: 'rgba(255, 255, 255, 0.74)',
                        paddingLeft: "8px",
                      }}
                    >
                      ahora
                    </Typography>

                    <Box sx={{display:"flex", alignItems: "center"}}>
                      <Box component="img" src={Logo} alt="icono" loading="lazy" sx={{
                        width: {xs:50, lg:70},
                        height: {xs:50, lg:70}
                      }} />
                      <Box sx={{paddingLeft:"6px"}}>
                        <Typography
                          sx={{
                            fontSize: {xs:'0.68rem', lg:'0.78rem'},
                            fontWeight: 700,
                            color: '#fff',
                          }}
                        >
                          Centro Quirúrgico San Rafael
                        </Typography>
                        <Typography
                          sx={{
                            mt: 0.3,
                            fontSize:{xs:'0.56rem', lg:'0.76rem'} ,
                            color: 'rgba(255,255,255,0.6)',
                          }}
                        >
                          Estamos listos para recibirte, con médicos profesionales altamente capacitados y equipo de última tecnología.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* NOTIFICATION */}
                  <Box
                    sx={{
                      mt: 1,
                      mx: 1.2,
                      padding:"9px 8px",
                      borderRadius: '18px',
                      position: 'relative',
                      zIndex: 10,
                      background: 'rgba(18,16,26,0.72)',
                      backdropFilter: 'blur(24px)',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {xs:'0.52rem', lg:'0.62rem'},
                        color: 'rgba(255, 255, 255, 0.74)',
                        paddingLeft: "8px",
                      }}
                    >
                      hace 2 min
                    </Typography>

                    <Box sx={{display:"flex", alignItems: "center"}}>
                      <Box component="img" src={DrTorres} alt="icono" loading="lazy" sx={{
                        width: {xs:50, lg:70},
                        height: {xs:50, lg:70}
                      }} />
                      <Box sx={{paddingLeft:"6px"}}>
                        <Typography
                          sx={{
                            fontSize: {xs:'0.68rem', lg:'0.78rem'},
                            fontWeight: 700,
                            color: '#fff',
                          }}
                        >
                          Dr. Héctor Leonardo Torres Soltero
                        </Typography>
                        <Typography
                          sx={{
                            mt: 0.3,
                            fontSize:{xs:'0.56rem', lg:'0.76rem'} ,
                            color: 'rgba(255,255,255,0.6)',
                          }}
                        >
                          Conoce nuestras instalaciones que abrieron sus puertas a la comunidad nayarita desde
                          el 6 de mayo de 1992.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* DOCK */}
                  <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{
                      position: 'absolute',
                      bottom: 16,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 10,
                      px: 1.8,
                      py: 1,
                      borderRadius: '20px',
                      background: 'rgba(0,0,0,0.22)',
                      backdropFilter: 'blur(16px)',
                    }}
                  >
                    {[
                      '#34d058',
                      '#5b7cf7',
                      '#ea4335',
                      '#f5a623',
                    ].map((bg, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: '11px',
                          background: bg,
                        }}
                      />
                    ))}
                  </Stack>

                  {/* HOME BAR */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 5,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 88,
                      height: 3.5,
                      borderRadius: '999px',
                      bgcolor: 'rgba(255,255,255,0.35)',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* SIDE PANEL */}
        <Stack spacing={3} maxWidth={250}>
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                letterSpacing: '-0.03em',
              }}
            >
              ¡Llama ahora!
            </Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: '22px',
                color: '#8a8880',
              }}
            >
              Centro Quirúrgico San Rafael siempre contigo.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: '16px',
              lineHeight: 1.6,
              color: '#999',
            }}
          >
            Marca al area correspondiente y con gusto te atenderemos, siempre listos para brindarte
            el mejor servicio.
          </Typography>

          <Button
            component="a"
            variant="contained"
            target="_blank"
            rel="noopener noreferrer"
            href="https://wa.me/3111095882"
            sx={{
              borderRadius: '12px',
              textTransform: 'none',
            }}
          >
            Comunicarse 
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CelularItem;